import { makeRequest } from 'utils/requestLogger';

export default (roundtable_id, payload) =>
  makeRequest(
    'post',
    `/api/roundtables/${roundtable_id}/send_email_reminder`,
    payload
  );



// WEBPACK FOOTER //
// ./src/app/features/onlineRoundtables/services/roundtable/sendEmailReminder.js